import { TrackingView } from "@/admin/marketing/TrackingView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/tracking")({
    component: TrackingView,
});
